import axios from 'axios'
// // define api uising
axios.defaults.headers.common['Content-Type'] = 'application/json'
axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*'
const api = {
  async get (url, req) {
    return new Promise((resolve, reject) => {
      axios({ method: 'get', url: url, params: req, crossdomain: true })
        .then(response => {
          if (response.status === 200 && response.data) {
            resolve(response.data)
          }
        })
        .catch(error => {
          switch (error.response) {
            case 400:
            case 401:
            case 403:
            case 500:
              break
            default:
              reject(error)
              break
          }
        })
    })
  },
  async post (url, req) {
    return new Promise((resolve, reject) => {
      if (req === undefined) {
        axios({ method: 'post', url: url, crossdomain: true })
          .then(response => {
            if (response.status === 200 && response.data) {
              resolve(response.data)
            }
          })
          .catch(error => {
            switch (error.response) {
              case 400:
                break
              case 401:
                break
              case 403:
                break
              case 500:
                break
              default:
                reject(error)
                break
            }
          })
      } else {
        axios({ method: 'post', url: url, data: req, crossdomain: true })
          .then(response => {
            if (response.status === 200 && response.data) {
              resolve(response.data)
            }
          })
          .catch(error => {
            switch (error.response) {
              case 400:
                break
              case 401:
                break
              case 403:
                break
              case 500:
                break
              default:
                reject(error)
                break
            }
          })
      }
    })
  },
  async patch (url, req) {
    return new Promise((resolve, reject) => {
      if (req === undefined) {
        axios({ method: 'patch', url: url, crossdomain: true })
          .then(response => {
            if (response.status === 200 && response.data) {
              resolve(response.data)
            }
          })
          .catch(error => {
            switch (error.response) {
              case 400:
                break
              case 401:
                break
              case 403:
                break
              case 500:
                break
              default:
                reject(error)
                break
            }
          })
      } else {
        axios({ method: 'patch', url: url, data: req, crossdomain: true })
          .then(response => {
            if (response.status === 200 && response.data) {
              resolve(response.data)
            }
          })
          .catch(error => {
            switch (error.response) {
              case 400:
                break
              case 401:
                break
              case 403:
                break
              case 500:
                break
              default:
                reject(error)
                break
            }
          })
      }
    })
  }
}

export default api
